import React from "react";
import FeatherIcon from "feather-icons-react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Chip, IconButton, Stack, Typography } from "@components/base";
import { useGetFormAssignmentConfig } from "@api";
import { useUserStore } from "@store/user";

interface ToolbarProps {}

const Toolbar: React.FC<ToolbarProps> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { formId } = useParams<{ formId: string }>();
  const { formAssignmentConfig } = useGetFormAssignmentConfig(user, { formId });

  const handleBack = (): void => {
    navigate("/question-assignment");
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center" mb={3}>
      {formId && (
        <IconButton onClick={handleBack} size="small">
          <FeatherIcon icon="arrow-left" size={20} />
        </IconButton>
      )}
      <Typography variant="subtitle1">{t("questionsAssignment.title")} </Typography>
      {formAssignmentConfig ? (
        <Chip color="orange1" label={formAssignmentConfig.name} />
      ) : null}
    </Stack>
  );
};

export default Toolbar;
